module.exports = "/_next/static/resources/box-a213a224744f723ad7f9e4c5620c9b4c.jpg";